<div class="reason-dialog-container">
  <img
    [src]="data.iconPath ? data.iconPath : 'assets/images/wargingGradient.svg'"
  />
  <div class="heading-container">
    <div class="heading">{{ data.heading }}</div>
    <div class="sub-heading" *ngIf="data.subHeading">{{ data.subHeading }}</div>
  </div>
  <div class="reason-block">
    <div>{{ data.reasonLabel ? data.reasonLabel : "Reason" }}</div>
    <div class="reason-desc">
      {{ data.reason }}
    </div>
  </div>
  <div class="action-buttons" *ngIf="data.submitButton">
    <button (click)="back()">{{ data?.backButtonName || "Close" }}</button>
    <button (click)="submit()">{{ data.submitButton }}</button>
  </div>
</div>
